import { jwtDecode } from 'jwt-decode';

// Save token and user role to localStorage
export const setAuthToken = (token, privileges) => {
  if (token) {
    localStorage.setItem('authToken', token);

    const decoded = jwtDecode(token);

    localStorage.setItem('role', decoded.role);
    localStorage.setItem('roleId', decoded.roleId || '');
    localStorage.setItem('roleName', decoded.roleName || '');
    const effectivePrivileges = Array.isArray(privileges)
      ? privileges
      : Array.isArray(decoded.privileges) ? decoded.privileges : [];
    localStorage.setItem('privileges', JSON.stringify(effectivePrivileges));
  } else {
    localStorage.removeItem('authToken');
    localStorage.removeItem('role');
    localStorage.removeItem('roleId');
    localStorage.removeItem('roleName');
    localStorage.removeItem('privileges');
  }
};


// Get token from localStorage
export const getAuthToken = () => localStorage.getItem('authToken');

// Check if the user is authenticated
export const isAuthenticated = () => {
  const token = getAuthToken();
  if (!token) return false;

  try {
    jwtDecode(token);
    return true;
  } catch (error) {
    // console.error("Invalid token:", error);
    logout();
    return false;
  }
};

// Get the user's role from localStorage
export const getUserRole = () => {
  const role = localStorage.getItem('role') || 'user';
  // console.log("Retrieved Role from Storage:", role); // Debugging
  return role;
};

export const getAssignedRoleName = () => localStorage.getItem('roleName') || '';

export const getUserPrivileges = () => {
  return JSON.parse(localStorage.getItem('privileges') || '[]');
};


// Logout function
export const logout = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('role');
  localStorage.removeItem('roleId');
  localStorage.removeItem('roleName');
  localStorage.removeItem('privileges');
  window.location.href = "/login";
};
